var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwords(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13 19 6-6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 17.5 3.586 6.586A2 2 0 013 5.172V3h2.172a2 2 0 011.414.586L17.5 14.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m14.828 6.172 2.586-2.586A2 2 0 0118.828 3H21v2.172a2 2 0 01-.586 1.414l-2.586 2.586"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m16 16 4 4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m19 21 2-2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m5 14 4 4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m5 21-2-2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16.5 4 20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwords);
export default __webpack_public_path__ + "static/media/swords.1f390b456e47f8e93cc1ec3aae41bc95.svg";
export { ForwardRef as ReactComponent };